/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import { FilterStorageFactory } from '@bingads-webui-campaign/filter-storage';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';

import { createSchemaProcessorForCurrentScope } from './schema-processors';

export function getCampaignAdgroupSelectorFilterConfig({
  scope = {},
  entitySchema,
  featureName,
  i18n,
  sessionStore,
  preferenceStoreFactory,
  customizedSchemaForProcessor,
  cacheService,
  dataContextManager,
  edmCampaign,
  jsdata,
  existingCampaignFilter,
  customizedGenerateSchemaForAdGroupProperty,
  customizedGenerateSchemaForCampaignProperty,
  generateSchemaForAccountProperty,
  preferenceService,
}) {
  const maxSavedFilterLimit = 10;
  const schemaI18n = new SchemaI18n({ i18n });

  return {
    entitySchema,
    schemaProcessor: createSchemaProcessorForCurrentScope({
      scope,
      customizedSchemaForProcessor: customizedSchemaForProcessor || cloneDeep(entitySchema),
      cacheService,
      dataContextManager,
      edmCampaign,
      i18n,
      jsdata,
      existingCampaignFilter,
      customizedGenerateSchemaForAdGroupProperty,
      customizedGenerateSchemaForCampaignProperty,
      generateSchemaForAccountProperty,
    }),
    schemaI18n,
    i18n,
    shortDateFormat: 'yMd',
    odata: {
      ignoreCase: false,
      custom: {},
    },
    maxSavedFilterLimit,
    storageFactory: new FilterStorageFactory({
      sessionStore,
      preferenceStoreFactory,
      featureName,
      maxSavedFilterLimit,
      parseIdAsInt: false,
      getLegacySaved: false,
      preferenceService,
    }),
    enabled: ['editor'],
    editor: {
      isComparingEnabled: () => true,
    },
  };
}
